import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as signup from '../actions/signup.actions';
import * as termsAndConditionsAction from '../actions/get-terms-and-conditions.actions';
import { NetworkCallService } from '../../../core/services/network-call.service';
import { Router } from '@angular/router';
import { catchError, map, switchMap } from 'rxjs/operators';
import { retryTransientHttpErrors } from '../../../core/operators/retry-transient-http-error.operator';
import { ISignupRequest, ISignupResponse } from '../models/signup.model';
import { of } from 'rxjs';
import { HelpersService } from '../../../../../src/app/core/services/helpers.service';
import { SessionStorageIds } from '../../../shared/enums';
import { TermsAndConditions } from '../models/terms-and-conditions.model';

@Injectable()
export class SignupEffects {
  constructor(
    private actions$: Actions,
    private networkCallService: NetworkCallService,
    private router: Router,
    private helperService: HelpersService
  ) {}

  signupRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(signup.loadSignupRequest),
      switchMap(action =>
        this.networkCallService
          .post<
            ISignupRequest,
            ISignupResponse
          >('Authentication/businessSignup', { ...action.request, ipAddress: sessionStorage.getItem('ipAddress') })
          .pipe(
            map(response => {
              if (response.success && response.accessToken !== null) {
                sessionStorage.setItem(SessionStorageIds.USER_MOBILE, action.request.mobileNumber);
                sessionStorage.setItem('token', response.accessToken);
                sessionStorage.setItem('refreshToken', response.refreshToken);
                this.helperService.decodeJwtToken(response.accessToken);
                this.router.navigateByUrl('auth/passcode');
              } else if (!response.success) {
                this.helperService.notifyError(`Please check your details and make sure you have entered a valid phone number`, 400, 3000);
              }
              return signup.loadSignupSuccess({ response });
            }),
            retryTransientHttpErrors(),
            catchError((error: any) => {
              return of(signup.loadSignupFailure(error));
            })
          )
      )
    )
  );

  getTermsAndConditions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(termsAndConditionsAction.loadGetTermsAndConditions),
      switchMap(action =>
        this.networkCallService
          .get<TermsAndConditions>('SignUpSignIn/TermsAndConditionsDocuments?dialingCode=' + action.request.dialingCode)
          .pipe(
            map(response => {
              return termsAndConditionsAction.loadGetTermsAndConditionsSuccess({ response });
            }),
            catchError((error: any) => {
              const errorMsg = error?.error?.Message || error?.error?.message || '';
              return of(termsAndConditionsAction.loadGetTermsAndConditionsFailure(error));
            })
          )
      )
    )
  );
}
